import { Box, Stack, Typography, useTheme } from "@mui/material"
import { getPlatform } from "../../../utilities/orientationAndPlatform"

export default function ScheduleButton({...params}){

    let pageMode = params.pageMode
    let setPageMode = params.setPageMode
    let isLive = params.isLive
    let theme = useTheme()
    let platform = getPlatform()

    let infoButtonState = params.infoButtonState
    let setInfoButtonState = params.setInfoButtonState
    let scheduleButtonState = params.scheduleButtonState
    let setScheduleButtonState = params.setScheduleButtonState

    const infoButtonOnClick = () => {
        if (pageMode === 'schedule') setPageMode('read')
        else return
    }

    const handleInfoButtonHover = (event) => {
        event.preventDefault()
        setInfoButtonState('hover')
    }

    const handleInfoButtonMouseOut = (event) => {
        event.preventDefault()
        setInfoButtonState('default')
    }

    const scheduleButtonOnClick = () => {
        if (pageMode === 'read') setPageMode('schedule')
        else return
    }

    const handleScheduleButtonHover = (event) => {
        event.preventDefault()
        setScheduleButtonState('hover')
    }

    const handleScheduleButtonMouseOut = (event) => {
        event.preventDefault()
        setScheduleButtonState('default')
    }

    let infoButtonFontColor = ''
    let scheduleButtonFontColor = ''
    let infoButtonColor = ''
    let scheduleButtonColor = ''
    let liveButtonColor = '#D20000'
    let containerOpacity = '100%'
    
    if (pageMode === 'schedule') {
        infoButtonFontColor = theme.palette.ChannelPage.subheader.fontfilled
        scheduleButtonFontColor = theme.palette.ChannelPage.subheader.fontdefault

        if (infoButtonState === 'default') infoButtonColor = '#06569D'
        else if (infoButtonState === 'hover') infoButtonColor = '#108DF9'
        
        scheduleButtonColor = theme.palette.ChannelPage.subheader.gray
    }

    else if (pageMode === 'read') {
        infoButtonFontColor = theme.palette.ChannelPage.subheader.fontdefault
        scheduleButtonFontColor = theme.palette.ChannelPage.subheader.fontfilled

        infoButtonColor = theme.palette.ChannelPage.subheader.gray
        
        if (scheduleButtonState === 'default') {
            scheduleButtonColor = '#06569D'
            liveButtonColor = "#D20000"
        }

        else if (scheduleButtonState === 'hover') {
            scheduleButtonColor = '#108DF9'
            liveButtonColor = '#DC375C'
        }
    }

    else if (pageMode === 'edit') { 
        infoButtonFontColor = theme.palette.ChannelPage.subheader.fontfilled
        scheduleButtonFontColor = theme.palette.ChannelPage.subheader.fontdefault  

        infoButtonColor = '#06569D'
        scheduleButtonColor = theme.palette.ChannelPage.subheader.gray
        containerOpacity = '50%'
    }


    let buttonSpacing = ''
    let stackWidth = ''
    if (platform === 'mobile'){
        stackWidth = '100%'
        if (isLive) buttonSpacing = '60px'
        else buttonSpacing = '20px'
    }
    else if (platform === 'desktop'){
        if (isLive) {
            buttonSpacing = '60px'
            stackWidth = '400px'
        } else {
            buttonSpacing = '20px'
            stackWidth = '325px'
        }
    }

    return (
        <Stack display={'flex'} justifyContent={'center'} direction={'row'} useFlexGap gap={buttonSpacing} width={stackWidth} sx={{opacity:containerOpacity}}>
            <Box alignSelf={'center'} sx={{backgroundColor: infoButtonColor}} borderRadius={'20px'} padding={'5px 10px'} width={'121px'} height={'35px'} 
                onClick={infoButtonOnClick}
                onMouseOut={(event) => handleInfoButtonMouseOut(event)} 
                onMouseOver={(event) => handleInfoButtonHover(event)}
            >
                <Typography align="center" color={infoButtonFontColor} fontSize={'18px'} fontWeight={400}>{'Information'}</Typography>
            </Box>
            <Box display={'grid'}>
                {(isLive) ? (
                    <>
                        <Box position={'relative'} right={'32px'} top={'50%'} 
                            onClick={scheduleButtonOnClick}
                            onMouseOut={(event) => handleScheduleButtonMouseOut(event)} 
                            onMouseOver={(event) => handleScheduleButtonHover(event)}
                        >
                            <Box backgroundColor={liveButtonColor} borderRadius={'20px'} width={'150px'} height={'34px'} padding={'5px 10px'} zIndex={1}>
                                <Typography color={'#FFFFFF'} fontSize={'18px'} fontWeight={400}>{'● Live'}</Typography>
                            </Box>
                        </Box>
                        <Box position={'relative'} left={'32px'} bottom={'50%'} 
                            onClick={scheduleButtonOnClick}
                            onMouseOut={(event) => handleScheduleButtonMouseOut(event)} 
                            onMouseOver={(event) => handleScheduleButtonHover(event)}
                        >
                            <Box backgroundColor={scheduleButtonColor} borderRadius={'20px'} padding={'5px 10px'} width={'186px'} height={'36px'} zIndex={9}>
                                <Typography color={scheduleButtonFontColor} fontSize={'18px'} fontWeight={400} zIndex={2001}>{'Broadcast Schedule'}</Typography>
                            </Box>
                        </Box>
                    </>
                ) : (
                    <Box display={'flex'} alignSelf={'center'} 
                        onClick={scheduleButtonOnClick}
                        onMouseOut={(event) => handleScheduleButtonMouseOut(event)} 
                        onMouseOver={(event) => handleScheduleButtonHover(event)}   
                    >
                        <Box backgroundColor={scheduleButtonColor} borderRadius={'20px'} padding={'5px 10px'} width={'186px'} height={'36px'} zIndex={9}>
                            <Typography color={scheduleButtonFontColor} fontSize={'18px'} fontWeight={400} zIndex={2001}>{'Broadcast Schedule'}</Typography>
                        </Box>
                    </Box>
                )} 
            </Box>
        </Stack>   
    )
}
